import { FormikProps, useFormik } from 'formik';
import { getAddExerciseOptionFormValidation } from './FormikData';
import { useTranslation } from 'react-i18next';
import { IExerciseOption } from '../../../../types/interfaces/exercise-option';
import { FormikValues } from 'formik/dist/types';
import { usePostPutExerciseOption } from '../../../../services/redux/api/exerciseConfigAPI';

export function useAddExerciseOptionComponent(
  onClose: () => void,
  exerciseOption?: IExerciseOption,
) {
  const { t } = useTranslation();
  const [postPutExerciseOption, { isLoading }] = usePostPutExerciseOption();

  const formik: FormikProps<any> = useFormik({
    enableReinitialize: true,
    validateOnChange: true,
    validationSchema: getAddExerciseOptionFormValidation(t),
    initialValues: {
      nameKey: exerciseOption?.nameKey || '',
      unitKey: exerciseOption?.unitKey || '',
      type: exerciseOption?.type || '',
      priorityOrder: exerciseOption?.priorityOrder || '',
      default: exerciseOption?.default || false,
      active: exerciseOption?.active || false,
    },
    onSubmit: onSubmit,
  });

  function onSubmit(values: FormikValues) {
    postPutExerciseOption({
      id: exerciseOption?.id,
      body: {
        nameKey: values.nameKey,
        unitKey: values.unitKey,
        type: values.type,
        priorityOrder: values.priorityOrder,
        default: values.default,
        active: values.active,
      },
    }).then((r) => {
      if (!('error' in r)) {
        onClose();
      }
    });
  }

  return { formik, isLoading };
}
